export const PAYMENT_PAGE_API_PATH = Object.freeze({
    PAYMENT_LINKS: "/api/v3/adyen/payment-links/",
    CHECKOUT_SESSIONS: "/checkout-sessions",
    ATTEMPTS: "/attempts",
    BANK_CHECK: "/bank-check",
    DETAILS: "/details",
    RESULT: "/result",
});

export const HTTP_METHOD = Object.freeze({
    GET: "GET",
    POST: "POST",
});

export const JSON_HEADERS = Object.freeze({ "Content-Type": "application/json" });

export const HTTP_STATUS_NOT_FOUND = 404;

export const PAYMENT_LINK_STATE = Object.freeze({
    OPEN: "OPEN",
    PAID: "PAID",
    EXPIRED: "EXPIRED",
    CLOSED: "CLOSED",
});

export const PAYMENT_REFUSAL = Object.freeze({
    LINK_PAID: "LINK_PAID",
    LINK_EXPIRED: "LINK_EXPIRED",
    LINK_CLOSED: "LINK_CLOSED",
    PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
    RELOAD_REQUIRED: "RELOAD_REQUIRED",
    SESSION_EXPIRED: "SESSION_EXPIRED",
    ATTEMPT_REPLACED: "ATTEMPT_REPLACED",
});

export const ADYEN_RESULT_CODE = Object.freeze({
    AUTHORISED: "Authorised",
    REFUSED: "Refused",
});

export const ADYEN_ENVIRONMENT_LIVE = "live";

export const ADYEN_CANCEL_ERROR_NAME = "CANCEL";

export const REDIRECT_RESULT_PARAMETER = "redirectResult";

export const ATTEMPT_STORAGE_KEY_PREFIX = "paymentLinkAttempt:";

export const PAGE_STATE_POLL_INTERVAL_MILLISECONDS = 3000;

export const BILLING_ADDRESS_MODE_FULL = "full";

export const TERMS_PAGE_ADDRESS = "/terms";

export const STATUS_TONE = Object.freeze({
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR",
    PROGRESS: "PROGRESS",
});

export const STATUS_ACTION = Object.freeze({
    NONE: "NONE",
    TRY_AGAIN: "TRY_AGAIN",
    RELOAD: "RELOAD",
});

export const PAGE_TEXT = Object.freeze({
    LOGO_ALTERNATIVE: "Yavrio Logo",
    PAYMENT_DETAILS: "Payment Details",
    LOADING: "Initializing secure payment session...",
    ORDER_SUMMARY: "Order Summary",
    ORDER_SUMMARY_UNREADABLE: "The order details can't be shown on this page. Your payment's result is shown here.",
    VENDOR: "Vendor",
    DESCRIPTION: "Description",
    AMOUNT: "Amount",
    REFERENCE_PREFIX: "Reference: ",
    SUBSCRIPTION_CARD_SAVED: "Your card will be saved for your subscription payments.",
    TERMS_LINK: "Payment link terms",
    TRY_AGAIN: "Try again",
    RELOAD_PAGE: "Reload page",
    UNABLE_TO_LOAD: "Unable to Load Payment",
    PAYMENT_SUCCESSFUL: "Payment Successful!",
    PAYMENT_SUCCESSFUL_BODY: "Your payment was successful. Thank you!",
    PAYMENT_REFUSED: "Payment Refused",
    PAYMENT_REFUSED_BODY: "Your payment was declined.",
    PAYMENT_REFUSED_FINAL_BODY:
        "Your payment was declined. This payment link can no longer be used. Please contact the seller.",
    PAYMENT_ERROR: "Payment Error",
    PAYMENT_ERROR_BODY: "There was an error processing your payment.",
    PAYMENT_FAILED_BODY: "Payment failed. Please try again.",
    LOAD_FAILED_BODY: "Failed to load payment",
    LINK_NOT_FOUND_BODY: "Payment link not found, Please Ensure you inputted the correct link",
    LINK_PAID_BODY: "Payment link has been used",
    LINK_EXPIRED_BODY: "Payment link expired",
    LINK_CLOSED_BODY: "This payment link can no longer be used. Please contact the seller.",
    PAYMENT_IN_PROGRESS: "Payment in Progress",
    PAYMENT_IN_PROGRESS_BODY: "A payment is already being processed on this link. This page will update by itself.",
    PAYMENT_STARTED_ELSEWHERE: "Payment Started Elsewhere",
    PAYMENT_STARTED_ELSEWHERE_BODY: "Another payment was started on this link. Reload this page to continue.",
    PAGE_TIMED_OUT: "Page Timed Out",
    PAGE_TIMED_OUT_BODY: "This page has timed out. Select Try again and re-enter your card details.",
    CHECKING_PAYMENT: "Checking Your Payment",
    CHECKING_PAYMENT_BODY:
        "An earlier payment on this link may already have gone through. This page will update once we've confirmed it.",
    CARD_DETAILS: "Card details",
    CARD_SAVING_SUMMARY: "Saving a card",
    CARD_SAVED: "Card Saved",
    CARD_SAVED_BODY: "Your card has been saved. You can close this window and return to the store.",
    CARD_ALREADY_SAVED_BODY: "This card has already been saved. You can close this window.",
});
